import { gql } from '@apollo/client';

/**
 * `public.mst_shop` — only request columns your Hasura role can select.
 */
export const GET_MST_SHOPS = gql`
  query GetMstShops {
    mst_shop(order_by: { id: asc }) {
      id
      shop_name
      shop_logo
      photo
      description
      business_address
      city
      state
      pincode
      mobile_number
      email
    }
  }
`;

export const GET_MST_SHOP_BY_PK = gql`
  query GetMstShopByPk($id: uuid!) {
    mst_shop_by_pk(id: $id) {
      id
      shop_name
      shop_logo
      photo
      description
      business_address
      city
      state
      pincode
      mobile_number
      email
    }
  }
`;
